export default {
	alarms: [],
	totalAlarms: 0,
	alarmsSetting: [],
	totalAlarmsSetting: 0
};
